import './Footer.scss';

// import {useState} from 'react';

import map from './map.jpg'
import machine from './machine.png';
import machine2 from './machine2.png';

// import Login from '../Login/Login';


import HomeWorkIcon from '@mui/icons-material/HomeWork';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import EmailIcon from '@mui/icons-material/Email';
// import LockTwoToneIcon from '@mui/icons-material/LockTwoTone';

import Social from '../socialLogos/SocialLogos';



const Footer = () => {

  // const [ShowLogin, setShowLogin] = useState(false);

  // const handlePageLog = () => {
  //   setShowLogin(!ShowLogin)
  // }
  
  return(
    <div className='footer'>
     <h2 className='footer_title'> - Contact - </h2>
        <p className='footer_txt'>Pour plus de renseignements ou une prise de rendez-vous : </p>
      <div className="footer_c">
        <div className='adresse'>
          <p className='footer_adresse-title'><HomeWorkIcon/> Adresse </p>
          <p className='footer_adresse'>22 avenue Camille pelletan</p>
          <p className='footer_adresse'>13127 Vitrolles.</p>
        </div>
        <div className="phone">
          <p className='phone_title'> <PhoneAndroidIcon/> Téléphone </p>
          <p className='phone_number'> <ArrowRightIcon/> 06 80 14 33 75 </p>
        </div>
        <div className='mail'>
          <p className='mail_title'> <EmailIcon/> Email</p>
          <a href='mailto:skinny.tattoo.contact@gmail.com'
          target='_blank' 
          className='mail_link' 
          rel="noreferrer"> 
          <ArrowRightIcon/> skinny.tattoo.contact@gmail.com
          </a>

        </div>

      </div> 
       
        <div className="map">
        
        <Social />
       
        <p className='where'> Où me trouver ?</p>

        <div className='map_container'>
          <img src={machine} alt='machine tattoo' className='machine1'/>

          <a href='https://www.google.com/maps/place/22+Av.+Camille+Pelletan,+13127+Vitrolles/@43.4591321,5.2470921,17z/data=!3m1!4b1!4m5!3m4!1s0x12c9ef3fdb3be91f:0x53e26922878a9e43!8m2!3d43.4591321!4d5.2492861?hl=fr' target='_blank' rel="noreferrer">
            <img src={map} alt='map cliquable vers localisation' className='map_p'/>

          </a>
          <img src={machine2} alt='machine tattoo' className='machine2'/>

        </div>

        </div>
 
    </div>
  )
}

export default Footer;